import { render } from "./LayourWrapper.vue?vue&type=template&id=18891ed0&scoped=true&ts=true"
import script from "./LayourWrapper.vue?vue&type=script&lang=ts"
export * from "./LayourWrapper.vue?vue&type=script&lang=ts"

import "./LayourWrapper.vue?vue&type=style&index=0&id=18891ed0&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18891ed0"]])

export default __exports__